import { NotificationChannelType } from "../../../../redux/type";

const CHANNEL_STYLES: Record<
  NotificationChannelType,
  { bg: string; text: string; dot: string; label: string }
> = {
  email: { bg: "bg-[#EFF6FF]", text: "text-[#2563EB]", dot: "bg-[#2563EB]", label: "Email" },
  push: { bg: "bg-[#F5F0FA]", text: "text-[#734792]", dot: "bg-[#734792]", label: "Push" },
  in_app: { bg: "bg-[#ECFDF5]", text: "text-[#059669]", dot: "bg-[#059669]", label: "In-App" },
};

interface NotificationChannelBadgeProps {
  channel: NotificationChannelType;
}

export default function NotificationChannelBadge({ channel }: NotificationChannelBadgeProps) {
  const styles = CHANNEL_STYLES[channel];

  return (
    <span
      className={`inline-flex items-center gap-[6px] rounded-full px-[10px] py-[4px] text-[12px] font-medium ${styles.bg} ${styles.text}`}
    >
      <span className={`size-[6px] rounded-full ${styles.dot}`} />
      {styles.label}
    </span>
  );
}
